<!--
 * @Author: Src
 * @Date: 2025-05-14 10:38:27
 * @LastEditTime: 2026-03-12 10:01:57
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/certificate/index.vue
 * @Description: 头部注释配置模板
-->
<template>
  <div>
    <div class="text_body">
      <div class="text_top">关于商户实名核验（法人手持身份证拍照上传）通知</div>
      <div class="text_next">
        为严格落实北京市丙类液体燃料安全管理标准及散装汽油油品安全管控要求，强化主体责任、实现源头可溯，现要求相关商户完成实名核验备案：
      </div>

      <ul class="text_ul">
        <li>
          1. 必须由法定代表人本人出镜，手持本人有效期内身份证原件正面拍照。
        </li>
        <li>
          <span> 2. 照片要求（可自行水印）：</span><br />
          <span> - 人脸清晰、无遮挡</span><br />
          <span> -身份证信息完整、清晰、可辨认，无反光、无模糊、无涂改；</span>
        </li>
        <li>3. 请按平台/管理方指定入口及时上传完成备案。</li>
        <li>
          4.
          未按要求上传、照片不合格或逾期未完成的，将按规定暂停相关经营权限，直至核验通过。
        </li>
      </ul>
      <div class="text_next">请各位商户高度重视、规范上传，确保合规经营。</div>
    </div>
    <!-- {{ token }}
    <div>商户编号：{{ bossId }}</div> -->
    <div>
      <div
        v-for="(item, index) in licenseArr"
        :key="index"
        class="licens_class"
      >
        <div>
          {{ item.credit_code }}
        </div>
        <div>
          <el-upload
            :action="`${BASE_URL}/tool/h5/upload/holdingId/photo`"
            :show-file-list="false"
            :data="{ bossId: bossId, businessLicenseCode: item.credit_code }"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-error="handleError"
            class="avatar-uploader"
            :accept="accept"
            :headers="{ AUTHORIZATION: token }"
            name="files"
            v-if="!item.holding_id_photo"
          >
            <div class="avatar-uploader-icon">
              <el-button size="small" type="primary">点击上传</el-button>
            </div>
          </el-upload>
          <div v-else>已上传</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import StorageService from '@/services/storage.service';
import ShopService from '@/services/shop.service';

@Component({
  components: {},
})
export default class certificate extends Vue {
  @lazyInject(StorageService)
  protected storage!: StorageService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  imageUrl = '';

  licenseArr = [];

  accept = 'image/*';
  uploading = false;

  @Prop({ type: String, default: '' })
  text?: string;

  BASE_URL = BASE_URL;

  @Prop({ type: String, default: '' })
  auth_code?: string;

  @Prop({ type: String, default: '' })
  type?: string;

  handleAvatarSuccess(res: any, file: any) {
    const url = res.data;
    this.getBusinessLicense();
    this.imageUrl = url[0].url;
    this.uploading = false;
  }
  handleError(error: any) {
    console.log(error);
    this.uploading = false;
    const errMessage = JSON.parse(error.message); // 获取错误信息
    this.$message.error(errMessage.error);
  }
  beforeAvatarUpload(file: any) {
    this.uploading = true;
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      this.$message.error('上传头像图片大小不能超过 20MB!');
    }

    return isLt2M;
  }
  emitSuccess(url: string) {
    this.uploading = false;
  }

  bossId: any = '';

  token: any = '';

  mounted() {
    // const { token } = this.$route.query;
    // const { bossId } = this.$route.params;
    // // const decoded = atob(bossId as string);
    // // const deToken = atob(token as string);
    // console.log('-----------------------');
    // console.log(token);
    // console.log(bossId);
    // // this.bossId = decoded;
    // // this.token = deToken;
    // console.log(JSON.stringify(this.$route.query),'mounted');
  }

  public async created() {
    // eslint-disable-next-line no-console
    // console.log(this.$route.query,'created');
    const { ticket } = this.$route.query;
    const { bossId } = this.$route.params;
    if (bossId && ticket) {
      const decoded = atob(bossId as string);
      const deToken = atob(ticket as string);
      this.bossId = decoded;
      this.token = deToken;
      const data = {
        token: deToken,
      };
      this.storage.set('user', data);
      this.getBusinessLicense();
    } else {
      console.log('未登录ddddddddddddd');
    }
  }

  async getBusinessLicense() {
    const res = await this.shopService.getShopBusinessLicense({
      bossId: this.bossId,
    });
    this.licenseArr = res;
    console.log(res);
  }
}
</script>
<style lang="scss" scoped>
.text_body {
  padding: 10px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 20px;

  .text_top {
    // font-size: 18px;
    // color: #ff0000;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: center;
  }
  .text_next {
    margin: 10px;
  }
  .text_ul {
    margin: 10px;
    li {
      list-style: none;
      line-height: 25px;
    }
  }
}
.licens_class {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0% 20px;
}
.avatar-uploader {
  width: 100px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
}
.avatar-uploader-icon {
  line-height: 20px;
}
.avatar {
  width: 80px;
  height: 80px;
}
</style>